module.exports = __webpack_public_path__ + "img/squiggle-eyes.ae811bf7.svg";